import { render, staticRenderFns } from "./OrderLogCard.vue?vue&type=template&id=08b06fe3"
import script from "./OrderLogCard.vue?vue&type=script&lang=js"
export * from "./OrderLogCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports